/** Türkiye GSM — DB'de 10 hane, başında 0/+90/90 olmadan saklanır */
export const normalizeTurkishPhone = (telefon) => {
  const digits = String(telefon || '').trim().replace(/\s/g, '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length === 12 && digits.startsWith('90')) return digits.slice(2);
  if (digits.length === 11 && digits.startsWith('0')) return digits.slice(1);
  if (digits.length === 10) return digits;
  if (digits.length > 10) return digits.slice(-10);
  return digits;
};

/** Ekranda 0 (5XX) XXX XX XX formatında göster */
export const formatTelefonGoster = (telefon) => {
  const n = normalizeTurkishPhone(telefon);
  if (n.length !== 10) return String(telefon || '').trim() || '—';
  return `0${n.slice(0, 3)} ${n.slice(3, 6)} ${n.slice(6, 8)} ${n.slice(8, 10)}`;
};
